export default __webpack_public_path__ + "static/media/domain_verification.175c7e64.svg";